var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PatrolTermComponent',{attrs:{"typeName":"設備点検 項目・サイクル設定","type":4,"settionStrageName":"FacilityTermStorageItemName"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }